import { On3IconAthleteVerified } from '@on3/icons';
import CirclePlus from '@on3/icons/src/components/CirclePlus';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { On3Recruit } from '@on3/ui-lib/components/Svg/On3Recruit';
import { recruitsSubConfig } from '@on3/ui-lib/utils/constants';
import { Link } from 'components/Link';
import { StarRating } from 'components/UI/StarRating/StarRating';
import useAthlete from 'contexts/AthleteProvider';
import { useState } from 'react';

import styles from './ClaimProfile.module.scss';

export const ClaimProfile = () => {
  const { athlete } = useAthlete();
  const [processing, setProcessing] = useState(false);

  const [firstName] = (athlete.name || '').split(' ');
  const highschoolName =
    athlete.highSchool?.knownAs || athlete.highSchool?.fullName;
  const highSchoolLink =
    athlete.highSchool?.urlSlug &&
    `/high-school/${athlete.highSchool.urlSlug}/`;

  const handleClaimProfile = async () => {
    setProcessing(true);

    const termId =
      process.env.NEXT_PUBLIC_APP_ENV === 'production'
        ? recruitsSubConfig.piano.production.termId
        : recruitsSubConfig.piano.dev.termId;
    const offerId =
      process.env.NEXT_PUBLIC_APP_ENV === 'production'
        ? recruitsSubConfig.piano.production.offerId
        : recruitsSubConfig.piano.dev.offerId;
    const formId =
      process.env.NEXT_PUBLIC_APP_ENV === 'production'
        ? recruitsSubConfig.piano.production.formId
        : recruitsSubConfig.piano.dev.formId;

    window.tp.offer.startCheckout({
      termId,
      offerId,
      formNameByTermId: JSON.stringify({ [termId]: formId }),
    });

    setTimeout(() => {
      setProcessing(false);
    }, 2000);
  };

  return (
    <div className={styles.page}>
      <section className={styles.section}>
        <header className={styles.header}>
          <On3Recruit variant="black" />
          <h1>Get a Profile. Be Recruited.</h1>
        </header>
        <div className={styles.containers}>
          <div className={styles.playerContainer}>
            <div className={styles.block}>
              <figure>
                <Avatar
                  domain={athlete.defaultAsset?.domain}
                  height={100}
                  source={athlete.defaultAsset?.source}
                  type={athlete.defaultAsset?.type}
                  width={100}
                />
              </figure>
              <div className={styles.details}>
                <Link href={`/db/${athlete.slug}/`}>
                  <h2>{athlete.name}</h2>
                </Link>
                <div className={styles.classYear}>
                  Class of {athlete.classYear}
                </div>
                <div className={styles.container}>
                  <div className={styles.measurements}>
                    {!!athlete.height && (
                      <dl>
                        <dt aria-label="Height">HT</dt>
                        <dd>{athlete.height}</dd>
                      </dl>
                    )}
                    {!!athlete.weight && (
                      <dl>
                        <dt aria-label="Weight">WT</dt>
                        <dd>{athlete.weight}</dd>
                      </dl>
                    )}
                    {athlete.primaryPosition?.abbreviation && (
                      <dl>
                        <dt aria-label="Position">POS</dt>
                        <dd>{athlete.primaryPosition.abbreviation}</dd>
                      </dl>
                    )}
                  </div>
                  <div className={styles.ranking}>
                    <div className={styles.label}>On3 Industry</div>
                    <div className={styles.group}>
                      <StarRating
                        fiveStarPlus={athlete.ranking?.fiveStarPlus}
                        hasBorder={false}
                        isBoldRating={false}
                        isConsensus
                        rating={athlete.ranking?.rating}
                        sport={athlete.primaryPosition?.sport?.name}
                        stars={athlete.ranking?.stars}
                        year={String(athlete.classYear)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.location}>
                <dl>
                  <dt>High School</dt>
                  <dd className={styles.highschool}>
                    <figure>
                      <Avatar
                        domain={athlete.highSchool?.defaultAsset?.domain}
                        height={15}
                        source={athlete.highSchool?.defaultAsset?.source}
                        teamAvatar
                        type={athlete.highSchool?.defaultAsset?.type}
                        width={15}
                      />
                    </figure>
                    <Link href={highSchoolLink}>{highschoolName}</Link>
                  </dd>
                </dl>
                <dl>
                  <dt>Hometown</dt>
                  <dd>{athlete.hometownName}</dd>
                </dl>
              </div>
            </div>

            <h3>{firstName}, claim your On3 Profile Today.</h3>
            <button
              disabled={processing}
              name="claim-profile"
              onClick={handleClaimProfile}
              type="button"
            >
              Claim Profile
            </button>
          </div>
          <div className={styles.benefits}>
            <header>
              <h3>On3+ Recruits Benefits</h3>
              <div>
                <span className="sr-only">Price: </span>
                <div className={styles.pricing}>
                  <span>${recruitsSubConfig.pricing.base}</span>
                  <span>
                    ${recruitsSubConfig.pricing.offer}/
                    {recruitsSubConfig.pricing.period}
                  </span>
                  <span>{recruitsSubConfig.pricing.discount} off</span>
                </div>
              </div>
            </header>
            <ul>
              {[
                'Get a Verified Profile',
                'Showcase Highlights and Stats',
                'Private Recruiting Dashboard',
                'Coaching Contact Directory',
                'Access NIL Valuations',
                'Scouting and Ranking Opportunity ',
                'Free On3 National Subscription',
              ].map((item, idx) => (
                <li className={styles.benefit} key={idx}>
                  <Link href="/recruits/search/">
                    <span>
                      {idx === 0 && <On3IconAthleteVerified />}
                      {item}
                    </span>
                    <CirclePlus aria-hidden={true} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};
